import '../scss/beautiful-taxonomy.scss';

const $ = jQuery;

$("form#beautiful-taxonomy-filters-form").addClass("pagewidth");
